import { Box as BoxMUI } from "@mui/material";
import styled from "styled-components";

import color from "../../constants/color";
import materialUI from "../../material-UI";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px;
  margin-top: 130px;
  -webkit-font-smoothing: antialiased;
  table,
  th,
  td {
    border: 1px solid #e0e0e0;
    border-collapse: collapse;
    table-layout: fixed;
  }
`;

export const Tabs = styled(materialUI.Tabs)`
  color: ${color.almostBlack};
  font-family: Inter;
  background-color: ${color.white};
  border-top-right-radius: 8px;
  border-bottom: 1px solid #d2d8e8;
  border-top-left-radius: 8px;
`;
export const Tab = styled(materialUI.Tab)`
  text-transform: none;
  font-family: Inter;
  height: 54px;
  color: ${color.Almostblack};
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.015em;
  padding: 16px 32px;
`;
export const Box = styled(BoxMUI)``;
